import { NavLink } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { COUPLE_NAMES, SITE_LOGO_MARK_URL } from "../../constants/siteContent";

export default function SiteNav() {
  const { isAuthenticated } = useAdminAuth();

  return (
    <header className="site-nav" role="banner">
      <div className="site-nav-inner">
        <NavLink to="/" className="site-nav-brand" end>
          <img
            src={SITE_LOGO_MARK_URL}
            alt=""
            width={36}
            height={36}
            className="site-nav-mark"
            decoding="async"
          />
          <span className="visually-hidden">{COUPLE_NAMES}</span>
        </NavLink>
        <nav className="site-nav-links" aria-label="Main">
          <NavLink to="/" className={({ isActive }) => `site-nav-link${isActive ? " site-nav-link--active" : ""}`} end>
            Home
          </NavLink>
          <NavLink
            to="/save-the-date"
            className={({ isActive }) => `site-nav-link${isActive ? " site-nav-link--active" : ""}`}
          >
            Save the date
          </NavLink>
          {isAuthenticated ? (
            <NavLink
              to="/admin"
              className={({ isActive }) => `site-nav-link site-nav-link--admin${isActive ? " site-nav-link--active" : ""}`}
            >
              Admin
            </NavLink>
          ) : null}
        </nav>
      </div>
    </header>
  );
}
